import React, { useState } from 'react';
import ForgotPasswordParams from '../types/ForgotPasswordParams';
import forgotPassword from '../api/forgotPassword';

const Main: React.FC = () => {
  const [custCode, setCustCode] = useState<string>("")
  const [email, setEmail] = useState<string>("")
  const [alertMessageOpen, setAlertMessageOpen] = useState<boolean>(false)
  const [alertMessages, setAlertMessages] = useState<string[]>([])
  const [isSubmitted, setSubmitted] = useState<boolean>(false)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const params: ForgotPasswordParams = {
      cust_code: custCode,
      email: email
    }

    try {
      await forgotPassword(params);
      setAlertMessageOpen(false);
      setSubmitted(true);
    } catch (err: any) {
      setAlertMessageOpen(true);
      // err.responseが存在し、かつerr.response.dataが存在する場合
      if (err.response && err.response.data && err.response.data.errors) {
        setAlertMessageOpen(true);
        setAlertMessages(err.response.data.errors);
      } else {
        // 予期せぬエラーの場合の処理
        setAlertMessageOpen(false);
        console.log('An unexpected error occurred:', err);
      }
    }
  }

  const messages = alertMessages.length === 0 ? '' : alertMessages.map((message: string) =>
    <li>{message}</li>
  );

  const form = (
    <div className="inner">
      <h1 className="c-ttl__01">パスワード変更</h1>
      <p className="c-ttl__02"><span>※パスワードを再設定します。</span></p>
      { alertMessageOpen &&
        <div className="contact-note" style={{marginTop: '20px', marginBottom: '0px'}}>
          <ul>
            { messages }
          </ul>
        </div>
      }
      <div className="contact-box">
        <div className="contact-box__left">
          <div className="mbpc-98 mbsp-32">
            <form onSubmit={handleSubmit}>
              <div className="contact-box__form js-item" id="id-01">
                <div className="contact-box__item">
                  <label className="contact-box__ttl">
                    <span>お客様ID</span>
                    <small>必須</small>
                  </label>
                  <div className="contact-box__ct">
                    <input name="cust_code" type="text" className="input" onChange={ event => setCustCode(event.target.value) } />
                  </div>
                </div>
                <div className="contact-box__item">
                  <label className="contact-box__ttl">
                    <span>メールアドレス</span>
                    <small>必須</small>
                  </label>
                  <div className="contact-box__ct">
                    <input name="email" type="text" className="input" onChange={ event => setEmail(event.target.value) } />
                  </div>
                </div>
              </div>
              <button type="submit" className="c-btn__01">認証メールを送信</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );

  const completed = (
    <div className="inner">
      <h1 className="c-ttl__01">パスワード変更認証メール送信完了</h1>
      <p className="c-txt__01"><span>お客様の登録メールアドレスに<br />パスワード変更の認証アドレスを送信致しました。</span></p>
    </div>
  );

  return (
    <React.Fragment>
      <main className="wrapper">
        <section className="sec-posts">
          { isSubmitted ? completed : form }
        </section>
      </main>
    </React.Fragment>
  );
}

export default Main;
